import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { object, string } from "yup";

import { AustraliaRightToWorkInputField } from "./AustraliaRightToWorkInputField";
import { AustraliaRightToWorkSummaryField } from "./AustraliaRightToWorkSummaryField";
import { FieldType } from "../types";

export function AustraliaRightToWorkField(
  field: components["schemas"]["AustraliaRightToWorkCheckField"]
): FieldType<components["schemas"]["AustraliaRightToWorkCheckField"]> {
  return {
    field,
    inputElement: (
      <AustraliaRightToWorkInputField key={field.name} field={field} />
    ),
    summaryElement: () => (
      <AustraliaRightToWorkSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value && {
      id: field.value.id,
      document_number: field.value.document_number,
      document_type: field.value.document_type,
      document_issuing_country: field.value.document_issuing_country,
      document_subtype: field.value.document_subtype,
      file_name: field.value.file_name,
      file_type: field.value.file_type,
      get_url: field.value.get_url,
    },
    schema: australiaRightToWorkSchema,
  };
}

export const australiaRightToWorkSchema = object()
  .shape({
    id: string().required(t("This field is required")),
    document_type: string().required().label(t("Document type")),
    document_issuing_country: string().required().label(t("Issuing country")),
    document_number: string().required().label(t("Document number")),
  })
  .required(t("This field is required"));
